import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';

declare var jQuery: any;
declare var $: any;
declare function Fuse(list, options): void;

/*---------------------------------------------- Variables Liferay ----------------------------------------------*/
declare var i18nVS: any;

declare var google: any;
declare var initAutocomplete: any;
declare var initDateInputs: any;
declare var setJsPreference: any;
declare var idCiudadLiferay: any;
declare var cityId: any;
declare var rutasOfrecidas: any;
declare var map: any;

declare var errorRecogiendoRutas: any;
declare var textoErrorRecogiendoRutas: any;

declare var nuevasRutasRecogidas: any;

declare function initMap(): any;
declare function calcRoute(): any;
declare function simplifyURL(actualURl: string): string;

declare var GlobalGetOrigins: any;
declare var GlobalGetOriginsByDestination: any;
declare var GlobalGetDestinationsByOrigin: any;
declare var GlobalGetDestinations: any;
declare var PortugalGetTimetable: any;

declare var portletNameOptimalPath: any; // Nombre del portlet en Liferay


@Component({
  selector: 'app-journey-search',
  templateUrl: './journey-search.component.html',
  styleUrls: ['./journey-search.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class AppComponent implements OnInit {
  /*------------------------------------------------ Variables VSC -------------------------------------------------*/
  i18nL = i18nVS;
  depClass = 'invisible';
  arrClass = 'invisible';
  classform = '';
  mapClass = 'hidden';
  dirClass = 'invisible';
  listClass = 'invisible';
  panelText = 'Abrir';

  textoErrorRecogiendoRutas = '';
  errorClass = 'invisible';
  spinnerClass = 'invisible';

  origenPrevioText = '';
  destinoPrevioText = '';

  rutasOfrecidas = [];

  // Clase que le añade un padding al componente cuando no esta desplegado
  optimalPathPaddingClass = "margin-bottom-form";

  // Polyline estandar de google
  flightPath = null;
  marcadorInicioRuta = null;
  marcadorFinalRuta = null;

  cachedOrigins: CachedStops = {
    allStops: null,
    selectedStopId: null
  }
  cachedDestinations: CachedStops = {
    allStops: null,
    selectedStopId: null
  }

  obj_cache = {
    cachedOrigins: this.cachedOrigins,
    cachedDestinations: this.cachedDestinations
  };

  portletName = ''; // Nombre del portlet

  MIN_SEARCH_LENGTH:number = 3;

  /*------------------------------- Funciones copiadas del portlet OptimalPath ----------------------------------------------*/

  // Ojo como el optimal path se mete en el tema
  public setTraducciones() {
    this.i18nL = i18nVS;
  }

  public routeClickedTS(i) {
    if (this.flightPath == null) {
      this.flightPath = new google.maps.Polyline({
        path: [],
        geodesic: true,
        strokeColor: '#205d95',
        strokeOpacity: 0.7,
        strokeWeight: 3
      });

      this.marcadorInicioRuta = new google.maps.Marker({
        position: { lat: 0, lng: 0 },
        title: "A"
      });

      this.marcadorFinalRuta = new google.maps.Marker({
        position: { lat: 0, lng: 0 },
        title: "B"
      });
    }

    this.flightPath.setMap(null);
    this.marcadorInicioRuta.setMap(null);
    this.marcadorFinalRuta.setMap(null);

    var flightPlanCoordinates = [];
    for (var x = 0; x < this.rutasOfrecidas[i].overview_path.length; x++) {
      var coordinates = { lat: this.rutasOfrecidas[i].overview_path[x].lat(), lng: this.rutasOfrecidas[i].overview_path[x].lng() };
      flightPlanCoordinates[x] = coordinates;
    }
    this.flightPath.setPath(flightPlanCoordinates);
    this.marcadorInicioRuta.setPosition(flightPlanCoordinates[0]);
    this.marcadorFinalRuta.setPosition(flightPlanCoordinates[flightPlanCoordinates.length - 1]);

    this.flightPath.setMap(map);
    this.zoomToObject(this.flightPath);
    this.marcadorInicioRuta.setMap(map);
    this.marcadorFinalRuta.setMap(map);
  }

  public zoomToObject(obj) {
    var bounds = new google.maps.LatLngBounds();
    var points = obj.getPath().getArray();
    for (var n = 0; n < points.length; n++) {
      bounds.extend(points[n]);
    }
    map.fitBounds(bounds);
  }


  public fireCalcRoute() {

    // Se resetean las clases
    this.listClass = 'visible';
    this.mapClass = 'visible';
    this.errorClass = 'invisible';
    this.dirClass = 'invisible';
    this.spinnerClass = 'invisible';
    this.textoErrorRecogiendoRutas = '';

    errorRecogiendoRutas = false;
    calcRoute();
    this.recogerRutasCorrutine();
  }


  public recogerRutasCorrutine() {
    if (rutasOfrecidas.length > 0 && nuevasRutasRecogidas) {
      nuevasRutasRecogidas = false;
      this.rutasOfrecidas = rutasOfrecidas;
      this.origenPrevioText = (<HTMLInputElement>document.getElementById('origen')).value;
      this.destinoPrevioText = (<HTMLInputElement>document.getElementById('destino')).value;

      // Se asignan las clases
      this.dirClass = 'visible';
      this.optimalPathPaddingClass = '';
      this.spinnerClass = 'invisible';
      this.errorClass = 'invisible'
      errorRecogiendoRutas = false;

      // Se asigna el valor no colapsado a todas las rutas
      for (var i = 0; i < rutasOfrecidas.length; i++) {
        this.expandedRoutes[i] = 0;
      }
      this.actualSelectedRoute = 0;
      initMap();
      this.routeClickedTS(0);
    } else if (errorRecogiendoRutas) { // En caso de error en la respuesta
      this.errorClass = 'visible';
      this.textoErrorRecogiendoRutas = textoErrorRecogiendoRutas;
      this.spinnerClass = 'invisible';
      setTimeout(() => this.recogerRutasCorrutine(), 0.50);
    } else { // Si aun se esta esperando respuesta
      this.spinnerClass = 'visible';
      this.errorClass = 'invisible'
      setTimeout(() => this.recogerRutasCorrutine(), 0.50);
    }
  }


  // Calcula el tiempo que te llevaria completar una de las rutas
  public getTotalTimeOfRoute(rutaConcreta) {
    let seconds = 0;
    for (let i = 0; i < rutaConcreta.legs.length; i++) {
      seconds += rutaConcreta.legs[i].duration.value;
    }

    var finalMinutes = Math.floor((seconds / 60) % 60);
    var finalHours = Math.floor((seconds / 3600) % 24);

    var finalTime = '';
    if (finalMinutes < 10) {
      finalTime = '0' + finalMinutes + 'm';
    } else {
      finalTime = finalMinutes.toString(10) + 'm';
    }

    if (finalHours < 10 && finalHours != 0) {
      finalTime = '0' + finalHours + 'h ' + finalTime;
    } else if (finalHours != 0) {
      finalTime = finalHours.toString(10) + 'h ' + finalTime;
    }

    return finalTime;
  }


  // Calcula si esta parte de la ruta es caminando (true) o en bus (false)
  public itsWalkingOrBus(stepConcreto) {
    if (stepConcreto.travel_mode == 'WALKING') {
      return true;
    } else {
      return false;
    }
  }


  public showForm() {
    this.classform = 'visible';
    this.dirClass = 'invisible';
    this.mapClass = 'hidden';
    this.panelText = 'Abrir';
    if (this.panelText === 'Cerrar') {
      this.togglePanel();
    }
  }


  public togglePanel() {
    if (this.panelText === 'Abrir') {
      this.panelText = 'Minimizar';
      this.listClass = 'visible';
    } else {
      this.panelText = 'Abrir';
      this.listClass = 'invisible';
    }
  }


  /**
  * Seleccionar preferencia: "Mejor ruta"/"Mejores transbordos"/"Caminar menos"/...
  */
  public setPreference($event) {
    setJsPreference($event.srcElement.value);
  }


  /**
  * Seleccionar momento de salida o de llegada: "Salir a"/"Llegar antes de"/"Ultimo servicio"...
  * Esta funcion no se esta usando actualmente,
  * ya que ocultamos el input "salida" que invocariaa esta funcion
  */
  public travelTime($event) {
    if ($event.srcElement.value === '') {
      this.depClass = 'invisible';
      this.arrClass = 'invisible';
    } else {
      if ($event.srcElement.value === 'departure') {
        this.depClass = '';
        this.arrClass = 'invisible';
      } else {
        this.depClass = 'invisible';
        this.arrClass = '';
      }
      initDateInputs();
    }
  }


  // 0 - no expandido, 1 - si expandido
  expandedRoutes = [];
  // La ruta que actualmente esta desplegada
  actualSelectedRoute = -1;
  public toggleColapsable(iteracion) {
    this.actualSelectedRoute = iteracion;
    this.routeClickedTS(iteracion);
    if (this.expandedRoutes[iteracion] == 0) {
      this.expandedRoutes[iteracion] = 1;
    } else {
      this.expandedRoutes[iteracion] = 0;
    }
  }


  public rutaSeleccionada(iteracion) {
    if (this.actualSelectedRoute == iteracion) {
      return false;
    }
    return true;
  }


  /** Calcula a que hora deberias estar en un punto de la ruta
  @param numeroStep: indica el punto (step) de la ruta
  Si numeroStep es superior a la cantidad de steps, se retorna la hora del fin de ruta
  Si no, se retorna la hora de salida del step
  */
  public calcularHoraStep(rutaConcreta, numeroStep) {
    if (numeroStep == rutaConcreta.legs[0].steps.length) {
      var horaFinRuta = rutaConcreta.legs[0].arrival_time;
      if (horaFinRuta !== undefined) {
        return horaFinRuta.text;
      } else {
				/* A veces Google no nos provee el valor del arrival_time.
				Esto tiene lugar en trayectos que solo son a pie. Entonces lo calculamos asi: */
        this.calcularHoraFinRuta(rutaConcreta);
      }
    }
    return this.calcularHoraSalidaStep(rutaConcreta, numeroStep);
  }


  public calcularHoraFinRuta(rutaConcreta) {
    var finRuta = rutaConcreta.legs.length;
		/* observar que finRuta no es el ultimo step, sino el ultimo+1.
		Si calculamos su "salida" obtendremos la ultima llegada, que es lo que buscamos */
    return this.calcularHoraSalidaStep(rutaConcreta, finRuta);
  }


  public calcularHoraSalidaStep(rutaConcreta, numeroStep) {
    var hours: number;
    var minutes: number;
    var seconds: number;
    var dateNow = new Date();

    if (rutaConcreta.legs[0].departure_time !== undefined) {
      if (numeroStep == 0) {
        return rutaConcreta.legs[0].departure_time.text;
      }
      var timeArray = rutaConcreta.legs[0].departure_time.text.split(":");
      hours = timeArray[0];
      minutes = timeArray[1][0] + timeArray[1][1];
    } else {
      /* A veces Google no nos provee el valor del departure_time. Esto tiene lugar en trayectos que solo son a pie.
      En tales casos, siendo el viaje a pie (no tiene horario), en lugar de retornar una cadena vacia,
      tomaremos como salida la hora actual: */
      var numeroStepValidado = Math.min(numeroStep, rutaConcreta.legs[0].steps.length - 1);
      var stepConcreto = rutaConcreta.legs[0].steps[numeroStepValidado];
      if (this.itsWalkingOrBus(stepConcreto)) {
        var hours = dateNow.getHours();
        var minutes = dateNow.getMinutes();
        if (numeroStep == 0) {
          return this.formatearHora(hours, minutes);
        }
      } else {
        return '';
      }
    }

    var seconds = (hours * 60 * 60) + (minutes * 60);
    for (let i = 0; i < numeroStep; i++) {
      seconds += rutaConcreta.legs[0].steps[i].duration.value;
    }

    var finalMinutes = Math.floor((seconds / 60) % 60);
    var finalHours = Math.floor((seconds / 3600) % 24);
    var finalTime = this.formatearHora(finalHours, finalMinutes);
    return finalTime;
  }


  public formatearHora(hours, minutes) {
    var finalTime = '';
    if (minutes < 10) {
      finalTime = '0' + minutes;
    } else {
      finalTime = minutes.toString(10);
    }
    if (hours < 10) {
      finalTime = '0' + hours + ':' + finalTime;
    } else {
      finalTime = hours.toString(10) + ':' + finalTime;
    }
    return finalTime;
  }



  /*---------------------------- WA-3999 Funciones para la carga de Origenes y Destinos ----------------------------*/


  /****
  * Funciones de  eventos en los inputs de Origenes
  ****/

  /** Cuando el foco se situa en el input 'origen' se limpia su contenido */
  public inputAddressOrigen(event: any) {
    event.target.value = '';
    event.target.setAttribute('position', "");
    // al haber vaciado el input de Origenes, el input de Destinos ya no tiene filtro: se cargara con todos los stops
    this.autocomplete_input(this.obj_cache.cachedDestinations.allStops, "destinations");
  }

  /**
  * Se llama a esta funcion ante el evento keyup del input de Origenes.
  * Ademas, la funcion "autocomplete" de JQuery que hemos asociado al input de Origenes
  * tambien hace que, cuando se produce el evento onKeyUp,
  * tambien tenga lugar el comportamiento declarado en su bloque "source:function(req, responseFn)"
  */
  public onKeyOrigen(event: any) {
    // si teclean en el campo Origenes,
    // mientras no hayan seleccionado algun origen del listado, hacemos lo siguiente:
    // 1 - limpiamos el valor de "position"
    event.target.setAttribute('position', "");
    // 2 - el input de Destinos ya no tiene filtro: se cargara con todos los stops
    this.autocomplete_input(this.obj_cache.cachedDestinations.allStops, "destinations");
  }


  /****
  * Funciones de  eventos en los inputs de Destinos
  ****/

  /** Cuando el foco se situa en el input 'destino' se limpia su contenido */
  public inputAddressDestino(event: any) {
    event.target.value = '';
    event.target.setAttribute('position', "");
    // al haber vaciado el input de Destinos, el input de Origenes ya no tiene filtro: se cargara con todos los stops
    this.autocomplete_input(this.obj_cache.cachedOrigins.allStops, "origins");
  }

  /**
  * Se llama a esta funcion ante el evento keyup del input de Destinos.
  * Ademas, la funcion "autocomplete" de JQuery que hemos asociado al input de Destinos
  * tambien hace que, cuando se produce el evento onKeyUp,
  * tambien tenga lugar el comportamiento declarado en su bloque "source:function(req, responseFn)"
  */
  public onKeyDestino(event: any) {
    if (event.target.value && event.target.value.length > this.MIN_SEARCH_LENGTH){
      // si teclean en el campo Destinos,
      // mientras no hayan seleccionado algun destino del listado, hacemos lo siguiente:
      // 1 - limpiamos el valor de "position"
      event.target.setAttribute('position', "");
      // 2 - el input de Origenes ya no tiene filtro: se cargara con todos los stops
      this.autocomplete_input(this.obj_cache.cachedOrigins.allStops, "origins");
    }
  }


  /****
  * Funciones para iniciar el proceso de descargas de Stops y rellenar los combos
  ****/

  public initializeOriginInputJS() {
    // Esta es la primera llamada a searchOrigins; aqui inicializamos la cache de todos los origenes
    this.searchOrigins("", this).subscribe(
      resp => { this.obj_cache.cachedOrigins.allStops = resp; this.autocomplete_input(resp, "origins") },
      (err) => this.errorEnElJson()
    );
  }

  public initializeDestinationInputJS() {
    // Esta es la primera llamada a searchOrigins; aqui inicializamos la cache de todos los destinos
    this.searchDestinations("", this).subscribe(
      resp => { this.obj_cache.cachedDestinations.allStops = resp; this.autocomplete_input(resp, "destinations") },
      (err) => this.errorEnElJson()
    );
  }

  /**
  * Descargar todos los Origenes e inicializar el combobox correspondiente
  */
  private searchOrigins(selectedStopId, superThis): Observable<Response> {
    var url = "";
    const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = new RequestOptions({ headers: headers });
    var requestBody = '';
     if (selectedStopId) {
        url = simplifyURL(GlobalGetOriginsByDestination);
        requestBody = "&" + superThis.portletName + 'cityId=' + cityId + "&" + superThis.portletName + 'destinationCode=' + selectedStopId;
     } else {
       url = simplifyURL(GlobalGetOrigins);
       requestBody = "&" + superThis.portletName + 'cityId=' + cityId;
     }
    return superThis.http.post(url, requestBody, options);
  }


  /**
  * Descargar todos los Destinos e inicializar el combobox correspondiente
  */
  private searchDestinations(selectedStopId, superThis): Observable<Response> {
    var url = "";
    const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = new RequestOptions({ headers: headers });
    var requestBody = '';
    if (selectedStopId) {
      url = simplifyURL(GlobalGetDestinationsByOrigin);
      requestBody = "&" + superThis.portletName + 'cityId=' + cityId + "&" + superThis.portletName + 'originCode=' + selectedStopId;
    } else {
      url = simplifyURL(GlobalGetDestinations);
      requestBody = "&" + superThis.portletName + 'cityId=' + cityId;
    }
    return superThis.http.post(url, requestBody, options);
  }


	/**
    * Funcion para implementar el autocompletado de JQuery,
    * sirve tanto para el input del combo de Origenes como el de Destinos
    */
  private autocomplete_input(data, typeInput) {
    // por refactorizar codigo sacamos la definicion de variables al metodo prepareAutoComplete,
    // y a continuacion las recuperamos mediante destructuracion
    var vars = this.prepareAutoComplete(typeInput);
    var { fieldCode, fieldToShow, input, refToCachedStops, refToSearchStopsFunction, typeStopsToFilter } = vars;
    var dataJSON = "";
    try {
      dataJSON = data.json();
    } catch (error) {
      // console.log("Autocomplete error");
      this.errorEnElJson();
      return;
    }
    var superThis = this;
    $(input).autocomplete({
      source: function(req, responseFn) {
        // Ante el evento de onKeyUp, se filtra el listado de elementos segun el nombre tecleado
        var verifiedJSON = null;
        // Busca resultados sobre todas las poblaciones, con la cadena introducida por el usuario
        if (dataJSON != null && req.term.length > 0) {
          verifiedJSON = dataJSON;
        }
        // filtramos
        var results = superThis.buildAutocomplete(verifiedJSON, req.term, fieldCode, fieldToShow);
        responseFn(results);
      },
      minLength: 0,
      select: function(event, ui) {
        // Ante el evento de seleccionar elemento en Origenes o Destinos:
        // - inicializar el value del input
        input.value = ui.item.value;
        // - inicializar el atributo position del input (no hacerlo con Jquery)
        // (es aqui donde convertimos los radianes a grados, ya que solo es necesario una vez seleccionado el stop elegido)
        var str_position = superThis.convertRadiansToDegreesString(ui.item.position);
        input.setAttribute("position", str_position);
        // - almacenar el id del Origen/Destino seleccionado:
        refToCachedStops.selectedStopId = ui.item.id;
        // - descargar Origenes/Destinos del destino/origen elegido (y en caso de exito, preparar autocompletado)
        refToSearchStopsFunction(refToCachedStops.selectedStopId, superThis).subscribe(
          resp => superThis.autocomplete_input(resp, typeStopsToFilter),
          (err) => superThis.errorEnElJson()
        );
        // - validar formulario (habilitara el boton CTA si el otro input tambien se ha rellenado)
        superThis.validateFormSearchJS();
      },
    });
  }


	/**
	Inicializa variables que se usaran en la funcion de autocomplete_input
	*/
  private prepareAutoComplete(typeInput: string) {
    var fieldCode: string;
    var fieldToShow: string;
    var inputId: string;
    var refToCachedStops: CachedStops;
    var refToSearchStopsFunction: any;
    var typeStopsToFilter: string;
    if (typeInput === 'origins') {
      fieldCode = "oriCod";
      fieldToShow = "origen";
      inputId = "origen";
      // referenciar al objeto de cachedOrigins
      refToCachedStops = this.obj_cache.cachedOrigins;
      // la funcion a invocar cuando seleccionen un item en Origenes, sera la de buscar destinos del origen:
      refToSearchStopsFunction = this.searchDestinations;
      // ...y dicha funcion se encargara de cargar el autocompletado del input de destinos:
      typeStopsToFilter = "destinations";
    } else if (typeInput === 'destinations') {
      fieldCode = "desCod";
      fieldToShow = "destino";
      inputId = "destino";
      // referenciar al objeto de cachedDestinations
      refToCachedStops = this.obj_cache.cachedDestinations;
      // la funcion a invocar cuando seleccionen un item en Destinos, sera la de buscar origenes del destino:
      refToSearchStopsFunction = this.searchOrigins;
      // ...y dicha funcion se encargara de cargar el autocompletado del input de origenes:
      typeStopsToFilter = "origins";
    }
    // var input: no lo definimos mediante Jquery, para evitar conflictos con su atributo position
    var input: HTMLInputElement = <HTMLInputElement>document.getElementById(inputId);
    return { fieldCode, fieldToShow, input, refToCachedStops, refToSearchStopsFunction, typeStopsToFilter };
  }


	/**
    * Si se ha seleccionado Origen y Destino, se habilita el boton de buscador
    */
  private validateFormSearchJS() {
    $("#buscarJourneySearch").prop("disabled", true);
    var valid = this.obj_cache.cachedOrigins.selectedStopId && this.obj_cache.cachedDestinations.selectedStopId;
    if (valid) {
      $("#buscarJourneySearch").prop("disabled", false);
    }
  }


	/**
    * Construye el array de elementos para el autocompletado del Combo,
    * segun el json de datos (data) y la cadena buscada (term)
    */
  private buildAutocomplete(data, term, fieldId, fieldToShow) {
    var results = [];
    // Se usa el fuse.js siguiendo el ejemplo del JourneySearch de PuertoRico
    // WA-3999: ponemos  keys:["find"]  para usar ese campo al filtrar, lo piden expresamente
    var options = {
      shouldSort: true,
      threshold: 0.2,
      location: 0,
      distance: 1000,
      maxPatternLength: 75,
      minMatchCharLength: 2,
      keys: ["find"]
    };

    if (data != null) {
      if (term != null && term.length > 0) {
        // usamos el algoritmo fuse.js para filtrar las ciudades padre por cadena introducida por el usuario
        term = this.accent_foldJS(term);
        var arrayDataStops = data.info;
        var fuse = new Fuse(arrayDataStops, options);
        data = fuse.search(term);
      }
      for (var i = 0; i < data.length; i++) {
        var item = data[i];
        // Actualmente la respuesta devuelve las coordenadas en radianes, pero necesitamos grados.
        // Sin embargo no hacemos la conversion aqui, porque no es necesario convertirlo para todos los stops,
        // sino solo para aquel que se seleccione.
        let stopId = item[fieldId];
        if (!stopId){
          stopId = item['oriCod']
        }

        results.push({
          value: item['find'],
          name: item['find'],
          id: stopId,
          position: { lat: item['latGPS'], lng: item['lonGPS'] }
        });
      }
    }
    return results;
  }


	/**
	* Quitamos los acentos de la cadena introducida por el usuario
	*/
  accentMapJS = { "á": "a", "é": "e", "í": "i", "ó": "o", "ú": "u", "Á": "A", "É": "E", "Í": "I", "Ó": "O", "Ú": "U" };
  private accent_foldJS(term) {
    var ret = "";
    for (var i = 0; i < term.length; i++) {
      ret += this.accentMapJS[term.charAt(i)] || term.charAt(i);
    }
    return ret;
  };


  private convertRadiansToDegreesString(obj_radians: any) {
    var lat = obj_radians.lat * (180 / Math.PI);
    var lng = obj_radians.lng * (180 / Math.PI);
    return "(" + lat + ", " + lng + ")";
  }


  private errorEnElJson() {
    // console.log('Error al recoger JSON desde los WS');
    this.errorClass = 'visible';
    this.textoErrorRecogiendoRutas = textoErrorRecogiendoRutas;
    this.spinnerClass = 'invisible';
  }


  /*--------------------------------------------- Eventos ------------------------------------------------------*/
  ngOnInit() {
    initMap();
    this.setTraducciones();
    // Inicialización de los inputs del buscador
    this.portletName = portletNameOptimalPath;
    this.initializeOriginInputJS();
    this.initializeDestinationInputJS();
  }

  /*--------------------------------------------- Constructores ------------------------------------------------*/
  constructor(private http: Http) { }
}

interface CachedStops {
  allStops: any;
  selectedStopId: string;
}



// WEBPACK FOOTER //
// ./src/app/journey-search.component.ts